function returnValueWithPercentage(unit, value) {
  return `${value} <span class="unit">${unit}</span>`;
}

export default returnValueWithPercentage;
